<br>
<br>

  <!--div class="panel-heading">
    <a class="centrado"><img src="./assets/img/cnsf.png"></a>
    <br><br>
    <h4 class="panel-title center">
      Constancias Digitales</h4>
  </div-->
  <label class="panel-title"> Constancias Digitales</label>
  <hr class="red">

  <div *ngIf="constancias?.length == 0" class="alert alert-info">
    No Se Encontraron Constancias No Descargadas En La Base De Datos
  </div>
  <button type="button" name="salir" class="btn btn-primary" (click)="salir()">Salir</button>
  <br>
  <br>
  <div  *ngIf="mostrarTabla">
    <div class="card-body">
     
        <table class="table table-bordered table-striped" >
          <thead>
            <tr>
              <th>No Costancia</th>
              <th>Fecha De Creación</th>
              <th>PROCESOS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let constancia of constancias">
                <td>{{constancia.numeroConstancia}}</td>
                <td>{{constancia.fechaImpresion}}</td>
                
                <td>
                  <button type="button" name="descargar" class="btn btn-primary" 
                  (click)="actualizaConstancia(constancia)">OBTEN CONSTANCIA</button>
                </td>
                
            </tr>
    
          </tbody>
        </table>
    
    </div>
    <div *ngIf="muestraDescarga">
      <a [href]='pdfSrc' download target="_blank" class="btn btn-primary" rel="noopener noreferrer" 
      (click)="refrescaVentana()">Descargar Constancia</a>
    </div>
    <br><br>
  </div>
  
  
  
